import { BASIS_POINTS_DIVISOR } from '@ui/constants/uiConfig';

import { PositionBasicPoints } from './useBatchPositionBasicPoints';

export function calculatePositionTotalPoints(
  points: PositionBasicPoints,
): number {
  const base = Number(points.openPoints) + Number(points.closePoints);
  if (!Number.isFinite(base) || base <= 0) return 0;

  const holding = Number(points.holdingBoostP) / BASIS_POINTS_DIVISOR;
  const team = Number(points.teamBoostP) / BASIS_POINTS_DIVISOR;

  const total = Math.floor(base * holding * team);
  
return total / 100;
}

export function calculateTeamBoost(volumeUSD: bigint): string {
  if (volumeUSD >= 8000000n * 10n ** 18n) {
    return '1.2';
  } else if (volumeUSD >= 4000000n * 10n ** 18n) {
    return '1.158';
  } else if (volumeUSD >= 2000000n * 10n ** 18n) {
    return '1.117';
  } else if (volumeUSD >= 1000000n * 10n ** 18n) {
    return '1.078';
  } else if (volumeUSD >= 600000n * 10n ** 18n) {
    return '1.05';
  }
  
return '1.0';
}
